module.exports = "/_next/static/images/Connections@2x-97884bca1ab12f776c36eebca81a208d.webp";